import {Breadcrumbs, Button, Dialog, TextField, Typography} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {Link, withRouter} from 'react-router-dom';
import InputList from '../Components/InputList';
import PageTitle from '../Layout/components/PageTitle';
import SideMenu from './components/SideMenu';
import {Root} from './ReferralEdit.css';
import {roleStr} from '../../common/common';
import instance from '../../request/http';
import {BASE_URL} from '../../store/config';
import {clone, getToday} from '../../common/utils';
import Toast from '../Layout/components/Toast';

const ADD = 0;
const VIEW = 1;
const EDIT = 2;

class ReferralEdit extends PureComponent {
    constructor(props) {
        super(props);
        const referral_id = this.getQueryVariable("id"),
            state = this.getQueryVariable("state");

        this.state = {
            error: null,
            isLoaded: false,
            referral_id: referral_id,
            menuData: [
                "BASIC REFERRAL INFO",
                // "SIGNING STAGE INFO",
                "PAYMENT STAGE INFO",
            ],
            contentData: [//type  1:text 2:date 3:note 4:auto 5:money 6:formula 7:title
                {
                    title: "Basic Referral Info",
                    expanded: false,
                    content: [
                        {
                            title: "",
                            key: "title",
                            value: "BASIC REFERRAL INFO",
                            type: 7,
                        }, {
                            title: "Date of Referral",
                            key: "referral_date",
                            value: "",
                            type: 2,
                        }, {
                            title: "Type of case",
                            key: "case_type",
                            value: "",
                            type: 1,
                        }, {
                            title: "Referor",
                            key: "referer",
                            value: "",
                            type: 4,
                        }, {
                            title: "Client name",
                            key: "client_name",
                            value: "",
                            type: 1,
                        }, {
                            title: "Client email",
                            key: "client_email",
                            value: "",
                            type: 1,
                        }, {
                            title: "Client phone number",
                            key: "client_phone",
                            value: "",
                            type: 1,
                        }, {
                            title: "Client Note",
                            key: "client_note",
                            value: "",
                            type: 3,
                        }, {
                            title: "",
                            key: "title",
                            value: "SIGNING STAGE INFO",
                            type: 7,
                        }, {
                            title: "Date of Signing",
                            key: "signing_date",
                            value: getToday(),
                            type: 2,
                        }, {
                            title: "Case Number",
                            key: "case_number",
                            value: "",
                            type: 1,
                        }
                    ]
                }, {
                    title: "Payment Records",
                    expanded: false,
                    content: [
                        {
                            title: "Date of Payment",
                            key: "payment_date",
                            value: getToday(),
                            type: 2,
                        }, {
                            title: "Date of Closing",
                            key: "complete_date",
                            value: getToday(),
                            type: 2,
                        }, {
                            title: "Fee Payment",
                            key: "payment",
                            value: "",
                            type: 5,
                        }, {
                            title: "Referral fee",
                            key: "referral_fee",
                            legal_fee: "",
                            rate: "",
                            type: 6
                        }
                    ]
                },
            ],
            menuIndex: 0,
            status: "",
            passNote: "",
            lockStep: 1,
            state: state,
            isPass: false,
            isComplete: false,
            openPassView: false,
            maxStatus: "",

            showAlert: false,
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleMenuIndex = this.handleMenuIndex.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePass = this.handlePass.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlePassCancel = this.handlePassCancel.bind(this);
        this.handlePassSubmit = this.handlePassSubmit.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const {
            error,
            isLoaded,
            state,
            status,
            menuData,
            menuIndex,
            contentData,
            isPass,
            isComplete,
            lockStep,
            openPassView,
            passNote,
            showAlert,
            showToast,
            toastMsg,
            toastState,
        } = this.state;

        if (error) {
            return <div>
                {error}
            </div>
        } else if (!isLoaded) {
            return <div>
                LOADING...
            </div>
        }


        const contentView = () => {
            if (!isPass) {
                if (isComplete) {
                    return <div className="complete-wapper c">
                        <div className="img"></div>
                        <div className="text">Great! You just completed a Referral Case!</div>
                        <Button variant="contained" color="primary" onClick={() => this.props.history.goBack()}>
                            RETURN TO REFEREE LIST
                        </Button>
                    </div>
                } else {
                    return <div className="card-content h h-t">
                        <div className="card-l">
                            <SideMenu
                                menuData={menuData}
                                menuIndex={menuIndex}
                                isLock={false}
                                lockStep={lockStep}
                                handleMenuIndex={this.handleMenuIndex}
                            />
                        </div>
                        <div className="card-r f">
                            <div className="line"></div>
                            <InputList
                                data={contentData[menuIndex <= contentData.length - 1 ? menuIndex : contentData.length - 1].content}
                                state={state}
                                ref={(child) => {
                                    this.inputList = child
                                }}
                            ></InputList>
                            <div className="line mb-20 mt-20"></div>
                            <div className="card-foot h h-r">
                                {btnView()}
                            </div>
                        </div>
                    </div>
                }
            } else {
                return <div className="complete-wapper c">
                    <div className="img"></div>
                    <div className="text">THANK YOU FOR SUBMITTING!</div>
                    <Button variant="contained" color="primary" onClick={() => this.props.history.goBack()}>RETURN TO
                        REFEREE LIST</Button>
                </div>
            }
        }
        const btnView = () => {
            if (state === EDIT) {
                if (menuIndex === 0) {
                    return <div>
                        <Button disabled={this.stepBtnDisabled("prev")} className="btn" variant="contained"
                                onClick={this.handlePrev}>previous</Button>
                        <Button disabled={this.stepBtnDisabled("save")} className="btn" variant="contained"
                                onClick={this.handleSave}>SAVE</Button>
                        <Button className="refealBtn" variant="contained" onClick={this.handlePass}>PASS THIS
                            REFERAL</Button>
                        <Button disabled={this.stepBtnDisabled("next")} variant="contained" color="primary"
                                onClick={this.handleNext}>GO TO PAYMENT STAGE</Button>
                    </div>
                } else if (menuIndex === 1) {
                    return <div>
                        <Button disabled={this.stepBtnDisabled("prev")} className="btn" variant="contained"
                                onClick={this.handlePrev}>previous</Button>
                        <Button disabled={this.stepBtnDisabled("save")} className="btn" variant="contained"
                                onClick={this.handleSave}>SAVE</Button>
                        <Button className="refealBtn" variant="contained" onClick={this.handlePass}>PASS THIS
                            REFERAL</Button>
                        <Button disabled={this.stepBtnDisabled("next")} variant="contained" color="primary"
                                onClick={this.handleNext}>CONFIRM TO COMPLETE</Button>
                    </div>
                }
            }
        }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <div className="title" onClick={() => this.props.history.goBack()}>Return Referee List</div>
                            <Typography className="crtTitle">{this.getTitle()}</Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="wapper c">
                    <div className="card">
                        <div className="card-head">
                            <div className="pageTitle">{this.getTitle()}</div>
                        </div>
                        {contentView()}
                    </div>
                </div>
                <Dialog maxWidth={false} open={openPassView}>
                    <div style={{width: "800px", padding: "30px 50px"}}>
                        <div className="c" style={{color: "#0060A0", fontWeight: "bold", fontSize: "16px"}}>PLEASE TYPE
                            THE REASON YOU PASSED THIS REFERRAL
                        </div>
                        <TextField
                            style={{width: "100%", marginTop: "30px"}}
                            multiline
                            rows="6"
                            value={passNote}
                            placeholder="Type here..."
                            onChange={e => this.handleChange(e, "passNote")}
                            margin="dense"
                            variant="outlined"
                        />
                        <div style={{
                            width: '100%',
                            height: '1px',
                            margin: "20px 0",
                            backgroundColor: '#A1A1A1',
                            opacity: '0.13'
                        }}></div>
                        <div className="h h-r">
                            <Button style={{marginRight: "20px"}} variant="contained"
                                    onClick={this.handlePassCancel}>CANCEL</Button>
                            <Button variant="contained" color="primary" onClick={this.handlePassSubmit}>SUBMIT</Button>
                        </div>
                    </div>
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }

    componentDidMount() {
        this.getReferral();
    }

    setData(data) {
        const contentData = this.extractInputData(data);
        console.log(contentData);
        this.setState({
            isLoaded: true,
            contentData,
            status: data.status,
            maxStatus: data.status,
        }, () => {
            this.updateStatus();
        })
    }

    updateStatus() {
        const {status} = this.state;
        let menuIndex = 0;
        let lockStep = 0;
        if (status === "referral") {
            menuIndex = 0;
            lockStep = 1;
        } else if (status === "signed") {
            menuIndex = 1;
            lockStep = 2;
        } else if (status === "completed") {
            menuIndex = 1;
            lockStep = 2;
        } else if (status === "pass") {
            menuIndex = 0;
            lockStep = 1;
        }
        this.setState({
            lockStep,
            menuIndex
        }, () => {
            this.doStep();
        })
    }

    extractInputData(data) {
        const contentData = clone(this.state.contentData);
        for (const contentObj of contentData) {
            for (const itemObj of contentObj.content) {
                if (itemObj.key === "referral_fee") {
                    itemObj.legal_fee = data.legal_fee;
                    itemObj.rate = data.rate * 100;
                    continue;
                }
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {
                        const obj = data[key];
                        if (itemObj.key === key) {
                            itemObj.value = obj;
                        }
                    }
                }
            }
        }
        return contentData;
    }

    handleMenuIndex(index) {
        this.setState({
            menuIndex: index,
        }, () => {
            this.doStep();
        })
    }

    handlePrev() {
        const {menuIndex} = this.state;
        if (menuIndex > 0) {
            this.setState({
                menuIndex: menuIndex - 1,
            }, () => {
                this.doStep();
            })
        }
    }

    //basic save -> referral
    //basic next -> referral

    //signing save -> referral
    //signing next -> signing

    //payment save -> signing
    //payment next -> complete
    handleNext() {
        const {menuIndex} = this.state;
        const doNext = this.doNext();
        if (doNext) {
            this.doStep((status) => {//存当前
                this.saveData(status, () => {
                    this.setState({
                        menuIndex: menuIndex + 1
                    }, () => {
                        this.doStep((status) => {
                            this.saveData(status);
                        });
                    })
                });
            });
        } else {
            this.showToast("Please fill in the complete information", "warning")
        }
    }

    doNext() {
        let data = this.inputList.getData();
        let datas = this.extractDataToParams(data);
        for (const key in datas) {
            if (key === "client_phone" || key === "client_email") {
                continue;
            }
            if (datas.hasOwnProperty(key)) {
                const value = datas[key];
                if (!value) {
                    console.log(key);
                    return false;
                }
            }
        }

        console.log("here");
        if (datas.hasOwnProperty('client_phone') && !datas['client_phone'] && datas.hasOwnProperty('client_email') && !datas['client_email']) {
            return false;
        }
        return true;
    }


    // referral->signed->completed
    doStep(callback) {
        const {menuIndex, lockStep} = this.state;
        let status = "";
        let crtlockStep = 1;
        if (menuIndex === 0) {
            status = "referral";
            crtlockStep = Math.max(lockStep, 1);
        } else if (menuIndex === 1) {
            status = "signed";
            crtlockStep = Math.max(lockStep, 2);
        } else if (menuIndex >= 2) {
            status = "completed";
            crtlockStep = Math.max(lockStep, 2);
        }
        const maxStatus = this.getMaxStatus(status);
        this.setState({
            status,
            maxStatus,
            lockStep: crtlockStep
        }, () => {
            if (callback) callback(this.state.status);
        })
    }

    getMaxStatus(status) {
        const {maxStatus} = this.state;
        let crtMaxStatus = maxStatus;
        if (status === "signed" && crtMaxStatus === "referral") {
            crtMaxStatus = status;
        } else if (status === "completed") {
            if (crtMaxStatus === "referral" || crtMaxStatus === "signed") {
                crtMaxStatus = status;
            }
        }
        return crtMaxStatus;
    }

    handleSave() {
        const {status} = this.state;
        console.log(status)
        this.saveData(status);
    }

    saveData(status = null, callback = null) {
        let data = this.inputList.getData();
        let params = this.extractDataToParams(data);
        if (status) {
            let isHigher = this.contrastStatus(status);
            const maxStatus = isHigher ? status : this.state.maxStatus;
            params["status"] = maxStatus;
        }
        this.editReferral(params, () => {
            if (callback) callback();
        });
    }

    //传入的status是否比maxStatus等级更高
    contrastStatus(status) {
        const {maxStatus} = this.state;
        if (status === maxStatus) {
            return false;
        } else if (status === "referral") {
            if (maxStatus === "signed" || maxStatus === "completed") {
                return false;
            } else {
                return true;
            }
        } else if (status === "signed") {
            if (maxStatus === "completed") {
                return false;
            } else {
                return true;
            }
        } else if (status === "completed") {
            return true;
        }
        return true;
    }

    extractDataToParams(dataArr) {
        let params = {};
        for (const obj of dataArr) {
            if (obj.key === "referral_fee") {
                params["rate"] = obj.rate / 100.00;
                params["legal_fee"] = obj.legal_fee;
            } else {
                params[obj.key] = obj.value;
            }
        }
        return params;
    }

    handlePass() {
        this.setState(() => ({
            openPassView: true
        }))
    }

    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }

    handlePassCancel(e) {
        this.setState(() => ({
            openPassView: false
        }))
    }

    handlePassSubmit(e) {
        this.setState(() => ({
            openPassView: false,
        }))
        const {passNote} = this.state;
        let params = {
            status: "pass",
            description: passNote,
        }
        this.passReferral(params);
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    stepBtnDisabled(type) {
        const {menuIndex, contentData} = this.state;
        if (type === "prev") {
            if (menuIndex <= 0) {
                return true;
            } else {
                return false;
            }
        } else if (type === "next") {
            if (menuIndex > contentData.length - 1) {
                return true;
            } else {
                return false;
            }
        } else if (type === "save") {
            return false;
        }
    }

    isDisabled() {
        const {state} = this.state;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }

    getTitle() {
        const {state} = this.state;
        if (state === VIEW) {
            return "VIEW REFERRAL";
        } else if (state === EDIT) {
            return "EDIT REFERRAL";
        } else {
            return "";
        }
    }

    getQueryVariable(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return parseInt(decodeURIComponent(r[2]));
        }
        return 0;
    }

    getReferral() {
        const {referral_id} = this.state;
        instance.get(BASE_URL + 'common/referrals/' + referral_id).then((res) => {
            const referralData = res.data.data;
            console.log("referralData", referralData);
            this.setData(referralData);
        }).catch((err) => {
            this.setState({
                error: 'ERROR! Please contact administrator.',
                isLoaded: true
            });
        })
    }

    editReferral(params, callback = null) {
        console.log(params);
        const {referral_id, contentData, menuIndex} = this.state;
        instance.put(BASE_URL + 'common/referrals/' + referral_id, params).then((res) => {
            if (menuIndex > contentData.length - 1) {
                this.setState(() => ({
                    isComplete: true
                }))
            }
            if (callback) callback();
            this.showToast("Save successfully", "success");
        }).catch((err) => {
        })
    }

    passReferral(params) {
        const {referral_id} = this.state;
        instance.put(BASE_URL + 'common/referrals/' + referral_id, params).then((res) => {
            this.setState(() => ({
                isPass: true
            }))
        }).catch((err) => {
        })
    }
}

export default withRouter(ReferralEdit);